module.exports = __webpack_public_path__ + "img/logo-w.9f060903.svg";